import { useEffect } from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Layout from "./components/layout/Layout";
import HomePage from "./pages/home/HomePage";
import SchoolPage from "./pages/school/SchoolPage";
import ProgramsPage from "./pages/programs/ProgramsPage";
import StudentLifePage from "./pages/student-life/StudentLifePage";
import ContactPage from "./pages/contact/ContactPage";
import RevisionPage from "./pages/revision/RevisionPage";
import NeurogamesPage from "./pages/neurogames/NeurogamesPage";
import SoftSkillsPage from "./pages/soft-skills/SoftSkillsPage";
import ProgrammeIAPage from "./pages/programme-ia/ProgrammeIAPage";
import InscriptionPage from "./pages/inscription/InscriptionPage";
import PortesOuvertesPage from "./pages/portes-ouvertes/PortesOuvertesPage";
import PostbacPage from "./pages/postbac/PostbacPage";
import PolitiqueConfidentialitePage from "./pages/politique-confidentialite/PolitiqueConfidentialitePage";
import PolitiqueConfidentialiteAppPage from "./pages/politique-confidentialite/PolitiqueConfidentialiteAppPage";
import ConditionsUtilisationPage from "./pages/conditions-utilisation/ConditionsUtilisationPage";
import AdminApp from "./pages/admin/AdminApp";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const LayoutRoutes = () => (
  <Layout>
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/notre-ecole" element={<SchoolPage />} />
      <Route path="/nos-cycles" element={<ProgramsPage />} />
      <Route path="/vie-etudiante" element={<StudentLifePage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/revision" element={<RevisionPage />} />
      <Route path="/programme-neurogames" element={<NeurogamesPage />} />
      <Route path="/programme-soft-skills" element={<SoftSkillsPage />} />
      <Route path="/programme-ia" element={<ProgrammeIAPage />} />
      <Route path="/inscription" element={<InscriptionPage />} />
      <Route path="/inscriptions-2026-2027" element={<InscriptionPage />} />
      <Route path="/visite" element={<InscriptionPage />} />
      <Route path="/politique-confidentialite" element={<PolitiqueConfidentialitePage />} />
      <Route path="/conditions-utilisation" element={<ConditionsUtilisationPage />} />
      {/* URL déclarée dans les fiches App Store et Play Store de l'application Sanaa
          Connect. Elle DOIT rester stable : la changer casse les deux fiches, et une
          politique de confidentialité injoignable est un motif de rejet en revue. */}
      <Route
        path="/sanaa-connect/politique-confidentialite"
        element={<PolitiqueConfidentialiteAppPage />}
      />
    </Routes>
  </Layout>
);

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/admin/*" element={<AdminApp />} />
        <Route path="/portes-ouvertes" element={<PortesOuvertesPage />} />
        <Route path="/prepa-post-bac" element={<PostbacPage />} />
        <Route path="*" element={<LayoutRoutes />} />
      </Routes>
    </Router>
  );
}

export default App;
